

import { z } from 'zod';




export const AddressSchema = z.object({
  addressId: z.string().uuid().optional().nullable() ,
  street: z.string().optional().nullable(),
  city: z.string().optional().nullable(),
  postalCode: z.string().optional().nullable()
  
})